<template>
	<div id="yktj" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading">
		<div class="yktj_main">
			<div class="query_info">
				<el-date-picker
					v-model="beginDate"
					type="datetime"
					placeholder="开始日期"
					class="czdateStyle"
					value-format="yyyy-MM-dd HH:mm:ss"
				>
				</el-date-picker>
				<el-date-picker
					v-model="endDate"
					type="datetime"
					placeholder="结束日期"
					class="czdateStyle"
					value-format="yyyy-MM-dd HH:mm:ss"
				>
				</el-date-picker>
				<el-button class="el-button--primary" @click="ykCxBtn">搜索</el-button>
			</div>
			<!-- 彩票的表格 -->
			<div class="czTable">
				<!-- 彩票表格 -->
				<el-table :data="czTableData" border stripe max-height="414" style="width: 100%">
					<el-table-column prop="yxtz" label="有效投注" width="144" :formatter="addSymbol" />
					<el-table-column prop="WinBonus" label="中奖金额" :formatter="addSymbol" />
					<el-table-column prop="Rebate" label="返点金额" :formatter="addSymbol" />
					<el-table-column prop="Activity" label="活动金额" :formatter="addSymbol" />
					<el-table-column prop="CashIn" label="充值总额" :formatter="addSymbol" />
					<el-table-column prop="CashOut" label="取款总额" :formatter="addSymbol" />
					<el-table-column prop="sum" label="盈亏总额" :formatter="addSymbol" />
					<div slot="empty">
						<!-- 表格为空的样式 -->
						<div class="table-empty">
							<img src="@/static/img/zjzh/empty.png" alt="" />
							<div class="table-empty-text">暂无记录</div>
						</div>
					</div>
				</el-table>
			</div>
		</div>
	</div>
</template>
<script>
// 引用axios封装文件
import { postAjax, getAjax } from "../../util/ajax.js";

export default {
	data() {
		return {
			loading: false,
			//日期
			beginDate: "",
			endDate: "",
			//表格数据
			czTableData: [],
		};
	},
	mounted() {
		this.initDate();
		this.ykCxBtn();
	},
	methods: {
		initDate() {
			let etad = new Date();
			let y = etad.getFullYear();
			let m = ("00" + (etad.getMonth() + 1)).slice(-2);
			let d = etad.getDate();
			let h = etad.getHours();
			d = h > 3 ? d : d - 1;
			this.beginDate = `${y}-${m}-${("00" + d).slice(-2)} 03:00:00`;
			this.endDate = `${y}-${m}-${("00" + (d + 1)).slice(-2)} 03:00:00`;
		},
		ykCxBtn() {
			this.czTableData = [];
			let that = this;
			let url = "api/OrderReport/GetAccReport";
			let data = {
				EndTime: this.endDate,
				StartTime: this.beginDate,
			};
			this.loading = true;
			postAjax(url, data)
				.then(data => {
					this.loading = false;
					if (data.IsSucess) {
						that.czTableData.push(data.Data);
						that.czTableData.map(item => {
							item.yxtz = item.TZCount;
							item.sum = item.WinBonus + item.Rebate + item.Activity - item.TZCount;
						});
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},
		//加上钱的符号
		addSymbol(row, column) {
			if (row[column.property]) {
				return "￥" + row[column.property].toFixed(2);
			} else {
				return "￥0";
			}
		},
	},
};
</script>

<style type="scss">
.yktj_main {
	padding: 20px 20px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderReport/yktj.vue